import { compose } from '../../../../src/web/utils/react';
import { editor, facilityWidget } from '../../../../src/web/components/widgets/decorators';
import { NAME, ID } from './properties';
import PromotionBanner from './PromotionBanner';
import Editor from './Editor';

export default compose(
  facilityWidget(
    { name: NAME, category: 'Promotions', componentId: ID },
  ),
  editor(Editor),
)(PromotionBanner);
